import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

const articleImages: Record<string, string> = {
  '91n-com-zuixin-rukou-dizhi': 'https://readdy.ai/api/search-image?query=Modern%20secure%20network%20access%20gateway%20with%20glowing%20portal%20entrance%2C%20clean%20minimal%20tech%20aesthetic%2C%20warm%20amber%20and%20white%20tones%2C%20abstract%20geometric%20shapes%2C%20soft%20lighting%2C%20professional%20atmosphere&width=800&height=500&seq=article-card-91n-com-zuixin-rukou-dizhi&orientation=landscape',
  '91n-com-xinshou-jiaocheng': 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20guide%20illustration%20with%20step%20by%20step%20tutorial%20visuals%2C%20clean%20modern%20interface%20mockup%2C%20warm%20welcoming%20colors%2C%20organized%20workspace%20with%20numbered%20steps%2C%20soft%20background&width=800&height=500&seq=article-card-91n-com-xinshou-jiaocheng&orientation=landscape',
  '91n-com-changjian-wenti-jieda': 'https://readdy.ai/api/search-image?query=Help%20desk%20and%20FAQ%20concept%20with%20organized%20question%20mark%20cards%2C%20clean%20modern%20design%2C%20warm%20amber%20and%20neutral%20tones%2C%20professional%20customer%20support%20atmosphere%2C%20floating%20question%20bubbles&width=800&height=500&seq=article-card-91n-com-changjian-wenti-jieda&orientation=landscape',
  '91n-com-anquan-fangwen-zhinan': 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%20with%20lock%20icon%20and%20protective%20layers%2C%20clean%20modern%20tech%20aesthetic%2C%20professional%20security%20theme%20with%20warm%20accents%2C%20abstract%20data%20protection%20visualization&width=800&height=500&seq=article-card-91n-com-anquan-fangwen-zhinan&orientation=landscape',
  '91n-com-pingtai-jieshao': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20overview%20with%20interconnected%20features%20display%2C%20clean%20professional%20layout%2C%20warm%20amber%20highlights%2C%20abstract%20network%20visualization%20on%20light%20background&width=800&height=500&seq=article-card-91n-com-pingtai-jieshao&orientation=landscape',
  '91n-com-yidongduan-jiaocheng': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20modern%20web%20interface%2C%20mobile%20browsing%20concept%2C%20clean%20minimal%20design%2C%20warm%20lighting%2C%20hands%20holding%20phone%20with%20app%20screen%20visible%2C%20professional%20tech%20photography&width=800&height=500&seq=article-card-91n-com-yidongduan-jiaocheng&orientation=landscape',
};

const latestArticles = articles.slice(0, 6);

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新文章</h2>
            <p className="text-foreground-600 text-sm md:text-base">查看最新的使用教程、安全指南和平台动态</p>
          </div>
          <Link
            to="/category/tutorial"
            className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            const imageUrl = articleImages[article.slug] || '';
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={imageUrl}
                    alt={article.title}
                    title={`${article.title} - 91n com 官方入口指南`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    {cat && (
                      <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-foreground-400 text-xs">{article.date}</span>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2 text-base line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-4">{article.excerpt}</p>
                  <div className="flex items-center gap-2 text-foreground-400 text-xs">
                    <i className="ri-time-line"></i>
                    <span>{article.readTime}</span>
                    <span className="mx-1">&middot;</span>
                    <i className="ri-eye-line"></i>
                    <span>{Math.floor(Math.random() * 5000) + 500} 阅读</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-1 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}